import { SectionHeader } from "@/components/SectionHeader";
import ecosystemHardware from "@/assets/ecosystem-hardware.webp";
import type { ReactNode } from "react";
import { BuildingDemo } from "./building-demo/BuildingDemo";

export function EcosystemSection() {
  return (
    <section
      id="ecosystem"
      className="px-2 sm:px-4 py-20 md:px-6 md:pb-16 md:pt-32"
    >
      <div className="mx-auto flex max-w-6xl flex-col gap-12 md:gap-16">
        <SectionHeader
          variant="centered"
          className="px-6 sm:px-4 md:px-0"
          eyebrow="The Somo ecosystem"
          title="Built to work together"
          body="From the devices installed throughout a property to the software that configures and monitors them, every part of Somo is built to work as one system."
        />

        <div className="flex flex-col gap-4 md:gap-6">
          <EcosystemCard
            title="Somo Hardware"
            body="Sensors, controllers, gateways, and interfaces connect Somo to the room."
          >
            <img
              loading="lazy"
              decoding="async"
              src={ecosystemHardware}
              alt="Somo keypads, thermostat and sensors with their room status readouts"
              className="relative left-1/2 w-[118%] max-w-none -translate-x-1/2"
            />
          </EcosystemCard>

          <EcosystemCard
            title="Somo Software"
            body="Configure, deploy, monitor, and manage Somo across rooms and properties."
          >
            <BuildingDemo className="w-full" />
          </EcosystemCard>
        </div>
      </div>
    </section>
  );
}

function EcosystemCard({
  title,
  body,
  children,
}: {
  title: string;
  body: string;
  children: ReactNode;
}) {
  return (
    <div className="flex h-110 flex-col gap-8 overflow-hidden rounded-card border border-primary bg-primary px-8 pt-8 md:h-auto md:items-center md:gap-16 md:px-6 md:pt-20 md:text-center">
      <div className="flex max-w-2xl flex-col gap-4 md:gap-6">
        <h3 className="text-balance text-lg leading-title text-primary md:text-2xl md:leading-snug">
          {title}
        </h3>
        <p className="text-sm leading-normal tracking-body text-secondary md:text-base">
          {body}
        </p>
      </div>
      {children}
    </div>
  );
}
